import script from "./GetStarted.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetStarted.vue?vue&type=script&setup=true&lang=ts"

import "./GetStarted.vue?vue&type=style&index=0&id=424cda47&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424cda47"]])

export default __exports__